export const numberToPercent = (number: number) => `${number * 100}%`;
